import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, dark = false }) => (
  <p
    className={`text-[11px] font-semibold uppercase tracking-[0.28em] ${
      dark ? "text-gold" : "text-panettone"
    }`}
  >
    {children}
  </p>
);
